// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { auditof87BatchSubstitution, uploadof87BatchSubstitution } from './repositories';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import BatchSubstitutionTable from './components/batch-substitution-table';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import FileUploadPanel from '../../shared/components/file-upload-panel';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class OF87BatchSubstitution extends Component {

    state = {
        file: null,
        results: null,
        submit: false
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();

    }

    handleFileUpload = file => {

        this.setState( {
            file
        } );

    }

    handleAudit = () => {

        this.props.increaseCounter();
        auditof87BatchSubstitution( this.state.file ).then( response => {

            if ( response.errors && response.errors.length ) {

                response.errors.forEach( element => {

                    this.props.createErrorMessage( `Error: ${element}` );

                } );

            }
            this.setState( {
                results: response.orderDetails,
                submit: false
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleUpload = () => {

        this.props.increaseCounter();
        uploadof87BatchSubstitution( this.state.file ).then( response => {

            if ( response.errors && response.errors.length ) {

                response.errors.forEach( element => {

                    this.props.createErrorMessage( `Error: ${element}` );

                } );

            } else this.props.createSuccessMessage( 'File Uploaded Successfully' );
            this.setState( {
                results: response.orderDetails,
                submit: true
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    render () {

        const { file, results, submit } = this.state;

        const fullRes = results && results.map( i => ( { ...i, submit } ) );

        const message = `${submit ? 'Upload' : 'Audit'} Results`;

        const msg = file ? 'File Selected. Drag a file here to replace it, or click to browse. Only CSV files are allowed.' : 'Drag a file here to upload it, or click to browse. Only CSV files are allowed.';

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">OF87 Batch Substitution</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-batch-substitution-options">
                            <FileUploadPanel
                                onFileDrop={this.handleFileUpload.bind( this.props )}
                                uploadLabel=" "
                                file={file}
                                message={msg}
                            />
                            <button className="primary-button" type="button" disabled={!file} onClick={this.handleAudit}>
                                <span> Audit File </span>
                            </button>
                            <button className="primary-button" type="button" disabled={!file} onClick={this.handleUpload}>
                                <span> Upload File </span>
                            </button>

                        </div>
                        {results && (
                            <div className="atp-top-options atp-batch-substitution-top-options">
                                <div className="batch-heading">
                                    {message}
                                </div>
                                <div className="export-button">
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                </div>
                            </div>
                        )}
                        {results && (
                            <BatchSubstitutionTable
                                results={fullRes}
                                ref={this.child}
                            />
                        )}
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

OF87BatchSubstitution.displayName = 'OF87BatchSubstitution';
OF87BatchSubstitution.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    createSuccessMessage: PropTypes.func,
    createErrorMessage: PropTypes.func
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( OF87BatchSubstitution ) );
